import React from 'react';
import styled from 'styled-components';
import { Contact } from '../components';

const PageContainer = styled.div`
  padding-top: 80px; /* Space for fixed header */
`;

const PageHeader = styled.div`
  background-color: #1e3a8a;
  color: white;
  padding: 4rem 2rem;
  text-align: center;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-family: 'Playfair Display', serif;
`;

const PageDescription = styled.p`
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const ContactPage = () => {
  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Contact Us</PageTitle>
        <PageDescription>
          Have questions or need more information? Reach out to our team.
          We're here to help you plan your perfect stay at Wular Water Front Resort.
        </PageDescription>
      </PageHeader>
      
      <Contact />
    </PageContainer>
  );
};

export default ContactPage;
